import { render } from "./SafetyPage.vue?vue&type=template&id=1d6797e3&ts=true"
import script from "./SafetyPage.vue?vue&type=script&lang=tsx"
export * from "./SafetyPage.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__